import React, { ReactElement, useContext } from "react";
import FormBuilder from "../../../FormBuilder/FormBuilder";
import { BsX } from "react-icons/bs";
import { TemplateObject } from "../../../../Models/TemplateObject";
import FormDataContext from "../../../../Contexts/FormData.context";
import InputContext from "../../../../Contexts/Input.Context";
import { useParams } from "react-router-dom";
import { formActionEnum, jsonKeyMapping } from "../../../../Config/Constants";
import { calculateListItem } from "../../../../Util/calculationHelper";

type Props = {
  inputFieldGroup: TemplateObject;
  formElement: TemplateObject;
  removeGroupFields: Function;
  groups: any;
};

const GroupElements = ({
  inputFieldGroup,
  removeGroupFields,
  formElement,
  groups,
}: Props): ReactElement => {
  const { state, dispatch } = useContext(FormDataContext);
  // prefer stepSlug provided via URL; callers (FormBuilder) may pass a stepSlugOverride in future
  const { stepName } = useParams();
  const { disableAutoAdvance } = useContext(InputContext);
  const { formData } = state;

  const removeStepKey = (field: any, index: any) => {
    const allFormData = { ...formData };
    const currentStep = stepName || "";
    const updateData = !!allFormData[currentStep]
      ? [...allFormData[currentStep]]
      : [];
    // const removedItem:any = []
    // const currentIndex = index + 1

    // updateData.forEach((item, i) => {
    //     if (currentIndex !== i) {
    //         removedItem.push(item)
    //     }
    // })

    // allFormData[currentStep] = removedItem

    const [_key, removeDynamicIndex] = field.split("field-");
    const groupElementMetaKey = `meta-data-${
      formElement[jsonKeyMapping.FORM_ID]
    }`;
    const filterIndex = formData[groupElementMetaKey].dynamicIndex.filter(
      (index: number) => index !== Number(removeDynamicIndex)
    );

    if (formElement.subTotal !== undefined) {
      inputFieldGroup[field].forEach((elem: any) => {
        if (
          elem.id.split("-")[0] === `${formElement[jsonKeyMapping.FORM_ID]}`
        ) {
          const subtotalId = `subtotal${formElement[jsonKeyMapping.FORM_ID]}`;
          let deletedTotalVal = formData[elem.id];
          let subTotalVal =
            formData[`subtotal${formElement[jsonKeyMapping.FORM_ID]}`];
          let finalVal = subTotalVal - deletedTotalVal;
          allFormData[subtotalId] = finalVal;
          const formElementData: TemplateObject = {};
          let removeKey = true;
          calculateListItem(
            formElementData,
            `${formElement[jsonKeyMapping.FORM_ID]}`,
            deletedTotalVal,
            formData,
            removeKey
          );
          Object.keys(formElementData).forEach(function (id, i) {
            if (i > 0) {
              var val = formElementData[id];
              allFormData[id] = val;
            }
          });
        }
      });
    }

    // const formElementData: TemplateObject = {}
    // if (filterIndex.length > 0) {
    //     formElementData[groupElementMetaKey] = { dynamicIndex: filterIndex }
    // } else {
    //      formElementData[groupElementMetaKey] = {}
    // }

    // if (formData[groupElementMetaKey]) {
    //     formElementData[groupElementMetaKey] = { ...formData[groupElementMetaKey], ...formElementData[groupElementMetaKey] }
    // }
    // if(filterIndex.length === 0){
    //     delete formElementData[groupElementMetaKey].dynamicIndex
    // }
    //     allFormData[groupElementMetaKey] = formElementData[groupElementMetaKey]
    //         delete allFormData[field.id];
    //     })
    dispatch({ type: formActionEnum.SET_FORM_DATA, payload: allFormData });
  };
  return (
    <>
      {Object.keys(inputFieldGroup).map((field: string, fieldIndex: number) => {
        return (
          <div
            key={fieldIndex}
            className="mt-3 position-relative card add-more-body"
          >
            <BsX
              className="close-icon mb-2 m-2 position-absolute top-0 end-0 "
              size={24}
              onClick={() => {
                removeGroupFields(field);
                //removeStepKey(field,fieldIndex)
              }}
            />
            <FormBuilder
              fieldIndex={fieldIndex + 1}
              formGroup={inputFieldGroup[field]}
              groups={groups}
              disableAutoAdvance={disableAutoAdvance}
            />
          </div>
        );
      })}
    </>
  );
};

export default GroupElements;
